<template>
  <div class="landing">
    <!-- Hero 区域 -->
    <div class="hero">
      <div class="layui-container hero-inner">
        <div class="hero-text">
          <h1 class="hero-title layui-anim layui-anim-upbit">银行卡转账支付</h1>
          <p class="hero-sub">请根据以下信息完成转账，系统将自动核验到账。</p>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="layui-container content">
      <!-- 加载中 -->
      <div v-if="loading" class="layui-anim layui-anim-fadein">
        <div class="layui-card">
          <div class="layui-card-body center loading-wrap">
            <div class="loader"></div>
            <p class="loading-text">正在加载支付信息...</p>
          </div>
        </div>
      </div>

      <!-- 错误提示 -->
      <div v-else-if="error" class="layui-anim layui-anim-fadein">
        <div class="layui-card">
          <div class="layui-card-body center">
            <span class="layui-badge">提示</span>
            <p class="error-text">{{ error }}</p>
          </div>
        </div>
      </div>

      <!-- 已支付提示 -->
      <div v-else-if="paid" class="layui-anim layui-anim-fadein">
        <div class="layui-card">
          <div class="layui-card-body center">
            <i class="layui-icon" style="font-size:28px;color:#10b981;">&#xe657;</i>
            <h3 class="timeout-title">订单已支付</h3>
            <p class="timeout-sub">请勿重复转账。</p>
          </div>
        </div>
      </div>

      <!-- 已超时提示 -->
      <div v-else-if="expired" class="layui-anim layui-anim-fadein">
        <div class="layui-card">
          <div class="layui-card-body center">
            <i class="layui-icon" style="font-size:28px;color:#ef4444;">&#x1006;</i>
            <h3 class="timeout-title">订单已超时</h3>
            <p class="timeout-sub">请返回并重新发起支付。</p>
          </div>
        </div>
      </div>

      <!-- 支付信息 -->
      <div v-else class="layui-row layui-col-space30 layui-anim layui-anim-upbit">
        <div class="layui-col-xs12 layui-col-md7">
          <div class="layui-card info-card">
            <div class="layui-card-header info-header">
              <span>订单支付信息</span>
              <span class="countdown" v-if="countdownSeconds > 0">
                剩余支付时间：
                <span class="countdown-time">{{ formattedCountdown }}</span>
              </span>
              <span class="countdown ended" v-else>支付倒计时已结束</span>
            </div>
            <div class="layui-card-body">
              <div class="layui-form layui-form-pane">
                <div
                  class="layui-form-item"
                  v-for="(value, key) in filteredInfoMap"
                  :key="key"
                  :class="{ 'amount-item': key === 'paymentAmount' }"
                >
                  <label class="layui-form-label">{{ value.label }}</label>
                  <div class="layui-input-block field-row">
                    <span
                      class="field-value"
                      :class="{ mono: key === 'payerAccount', amount: key === 'paymentAmount' }"
                    >
                      {{ data[value.key] }}
                    </span>
                    <button
                      class="layui-btn layui-btn-normal layui-btn-sm copy-btn"
                      @click="copyText(data[value.key])"
                    >
                      复制
                    </button>
                  </div>
                </div>
              </div>
              <div class="tips">
                <i class="layui-icon">&#xe702;</i>
                请仔细核对以上信息，转账请备注订单号以便快速核验。
              </div>
            </div>
          </div>
        </div>

        <div class="layui-col-xs12 layui-col-md5">
          <div class="layui-card side-card">
            <div class="layui-card-header">温馨提示</div>
            <div class="layui-card-body">
              <ul class="layui-timeline">
                <li class="layui-timeline-item">
                  <i class="layui-icon layui-timeline-axis">&#xe63f;</i>
                  <div class="layui-timeline-content layui-text">
                    <h3 class="layui-timeline-title">到账时间</h3>
                    <p>同银行一般实时到账，跨行可能延迟，请耐心等待。</p>
                  </div>
                </li>
                <li class="layui-timeline-item">
                  <i class="layui-icon layui-timeline-axis">&#xe66f;</i>
                  <div class="layui-timeline-content layui-text">
                    <h3 class="layui-timeline-title">金额一致</h3>
                    <p>请按页面金额转账，若不一致可能无法自动匹配。</p>
                  </div>
                </li>
                <li class="layui-timeline-item">
                  <i class="layui-icon layui-timeline-axis">&#xe6b2;</i>
                  <div class="layui-timeline-content layui-text">
                    <h3 class="layui-timeline-title">防骗提醒</h3>
                    <p>谨防冒充客服的电话或短信，不要透露任何验证码。</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiConfig from "@/config/api";

export default {
  name: "BankTransferLanding",
  data() {
    return {
      data: {},
      loading: true,
      error: null,
      countdownSeconds: 0,
      countdownTimerId: null,
      expired: false,
      paid: false,
      infoMap: {
        merchantOrderNo: { label: "订单号", key: "merchantOrderNo" },
        payerBankName: { label: "收款方式", key: "payerBankName" },
        payerName: { label: "收款人", key: "payerName" },
        payerAccount: { label: "收款账号", key: "payerAccount" },
        payerBankBranchName: { label: "支行名称", key: "payerBankBranchName" },
        paymentAmount: { label: "支付金额", key: "paymentAmount" }
      }
    };
  },
  methods: {
    copyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      if (window.layui?.layer) {
        window.layui.layer.msg("已复制到剪贴板", { icon: 1, time: 1500 });
      } else {
        alert("✅ 已复制到剪贴板");
      }
    },
    startCountdown(totalSeconds) {
      this.clearCountdown();
      this.countdownSeconds = totalSeconds;
      this.countdownTimerId = setInterval(() => {
        if (this.countdownSeconds > 0) {
          this.countdownSeconds--;
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
        this.countdownTimerId = null;
      }
    },
    handleWebSocketMessage(data) {
      const merchantOrderNo = this.data.merchantOrderNo;
      console.log("📩 收到推送消息：", data);
      if (data.type === "order_timeout" && data.merchantOrderNo === merchantOrderNo) {
        console.warn("⏱ 收到订单超时推送");
        this.clearCountdown();
        this.expired = true;
      }
      if (data.type === "order_paid" && data.merchantOrderNo === merchantOrderNo) {
        console.log("💰 收到订单到账推送");
        this.clearCountdown();
        this.paid = true;
      }
    }
  },
  created() {
    const merchantOrderNo = this.$route.params.merchantOrderNo;
    this.$ws.connect();
    this.$ws._handleMessage = (rawData) => {
      let data = rawData;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          console.error("❌ WebSocket 消息解析失败", rawData);
          return;
        }
      }
      this.handleWebSocketMessage(data);
    };
    axios
      .get(apiConfig.getCommonInterfaceUrl(), {
        params: { merchantOrderNo }
      })
      .then((res) => {
        if (res.data.code === 200) {
          this.data = res.data.data;
          const expireTime = new Date(this.data.expire_time).getTime();
          const nowTime = Date.now();
          const diffSeconds = Math.floor((expireTime - nowTime) / 1000);
          if (diffSeconds > 0) {
            this.startCountdown(diffSeconds);
          } else {
            this.expired = true;
          }
          this.$ws.send(
            JSON.stringify({
              type: "bind_order",
              merchantOrderNo
            })
          );
        } else {
          this.error = res.data.msg || "订单获取失败";
        }
      })
      .catch(() => {
        this.error = "请求失败，无法获取订单信息";
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    formattedCountdown() {
      const mins = Math.floor(this.countdownSeconds / 60);
      const secs = this.countdownSeconds % 60;
      return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    },
    filteredInfoMap() {
      const result = { ...this.infoMap };
      // 若支行名称为空则不显示
      if (!this.data.payerBankBranchName) {
        delete result.payerBankBranchName;
      }
      return result;
    }
  },
  beforeDestroy() {
    this.clearCountdown();
  }
};
</script>








<style scoped>
/* Apple风格布局 */
.landing {
  background-color: #f5f5f7;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif;
}

.hero {
  background: #ffffff;
  color: #1d1d1f;
  padding: 60px 0 40px;
  text-align: center;
  border-bottom: 1px solid #d2d2d7;
}

.hero-title {
  font-size: 48px;
  font-weight: 600;
  margin: 0 0 12px;
  letter-spacing: -0.015em;
  color: #1d1d1f;
}

.hero-sub {
  font-size: 21px;
  font-weight: 400;
  color: #86868b;
  margin: 0;
}

.content {
  margin: 40px auto 80px;
  max-width: 980px;
  padding: 0 22px;
}

/* Apple风格卡片 */
.layui-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.08);
  border: 1px solid #f5f5f7;
  overflow: hidden;
  margin-bottom: 24px;
}

.layui-card-header {
  background: transparent;
  border: none;
  padding: 28px 28px 0;
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
}

.info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.countdown {
  font-size: 14px;
  color: #0071e3;
  font-weight: 400;
}

.countdown.ended {
  color: #d70015;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  margin: 0;
  margin-left: 0;
  flex: 1;
  min-width: 0;
  height: auto;
}

.field-value {
  font-size: 17px;
  color: #1d1d1f;
  flex: 1;
  min-width: 100px;
  word-break: break-all;
  line-height: 22px !important;
  margin: 0;
  padding: 0;
  height: 22px;
  display: inline-block;
}

.field-value.mono {
  font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
}

.field-value.amount {
  font-size: 17px;
  font-weight: 400;
  color: #1d1d1f;
}

/* Apple风格按钮 */
.copy-btn {
  min-width: 80px;
  background: #0071e3;
  border: none;
  border-radius: 980px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 16px;
  transition: all 0.2s ease;
  line-height: 22px !important;
  height: 34px;
  white-space: nowrap;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.copy-btn:hover {
  background: #0077ed;
  transform: scale(1.05);
}

.copy-btn:active {
  transform: scale(0.98);
}

.layui-card-body {
  padding: 0 28px 28px;
}

/* 表单项样式 */
.layui-form-item {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f5f5f7;
  display: flex !important;
  align-items: center !important;
  gap: 0;
}

.layui-form-item:first-child {
  margin-top: 0;
  padding-top: 8px;
}

.layui-form-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}


.layui-form-label {
  font-size: 15px;
  font-weight: 500;
  color: #86868b !important;
  width: 90px !important;
  min-width: 90px !important;
  text-align: left !important;
  padding: 0 !important;
  line-height: 22px !important;
  margin: 0 !important;
  margin-right: 8px !important;
  background: none !important;
  border: none !important;
  display: flex !important;
  align-items: center !important;
  float: none !important;
  height: 22px !important;
}


.layui-form {
  margin: 0;
}

.layui-input-block {
  margin-left: 0 !important;
  width: auto;
  flex: 1;
}

.tips {
  margin-top: 24px;
  padding: 16px;
  border-radius: 12px;
  background: #f5f5f7;
  color: #6e6e73;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.5;
}

.tips i {
  font-size: 16px;
  color: #0071e3;
  flex-shrink: 0;
}

.cta {
  margin-top: 16px;
}

/* 加载与错误 */
.center {
  text-align: center;
}

.loading-wrap {
  padding: 60px 0;
}

.loading-text {
  color: #86868b;
  font-size: 17px;
  margin-top: 16px;
}

.error-text {
  color: #d70015;
  margin-top: 16px;
  font-size: 17px;
}

.loader {
  width: 40px;
  height: 40px;
  border: 3px solid #f5f5f7;
  border-top-color: #0071e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 8px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .landing {
    padding-bottom: env(safe-area-inset-bottom);
  }

  .info-header {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .countdown {
    font-size: 12px;
    margin-left: auto;
  }

  .hero {
    padding: 40px 0 24px;
  }

  .hero-title {
    font-size: 28px;
  }

  .hero-sub {
    font-size: 15px;
  }

  .content {
    margin: 24px auto 0;
    padding: 0 20px;
    padding-bottom: max(40px, env(safe-area-inset-bottom) + 20px);
  }

  .layui-card-header {
    padding: 16px 16px 0;
    font-size: 15px;
  }

  .layui-card-body {
    padding: 0 16px 16px;
  }

  .field-row {
    gap: 8px;
    flex-wrap: nowrap;
  }

  .field-value {
    font-size: 16px;
    min-width: 0;
    flex: 1;
  }

  .field-value.mono {
    font-size: 16px;
  }

  .field-value.amount {
    font-size: 16px;
  }

  .copy-btn {
    min-width: 80px;
    flex-shrink: 0;
  }

  .tips {
    font-size: 13px;
    margin-top: 16px;
  }

  .layui-form-item {
    margin-bottom: 12px;
    padding-bottom: 12px;
  }

  .layui-form-item:first-child {
    padding-top: 4px;
  }

  .layui-card {
    margin-bottom: 16px;
  }

  .layui-card:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .info-card {
    margin-bottom: 12px;
  }

  .side-card {
    margin-top: 16px;
  }

  .layui-row[class*="layui-col-space"] > [class*="layui-col-"] {
    padding: 0 0 !important;
  }

  .layui-row[class*="layui-col-space30"] > [class*="layui-col-"] {
    padding: 0 0 !important;
  }

  .side-card .layui-timeline-item {
    padding-bottom: 12px;
    margin-bottom: 12px;
  }

  .side-card .layui-timeline-title {
    font-size: 14px;
    margin: 0 0 4px;
  }

  .side-card .layui-timeline-content p {
    font-size: 13px;
  }
}

/* 极窄屏处理 */
@media (max-width: 360px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-sub {
    font-size: 15px;
  }
}

.countdown-time {
  color: #d70015;
  font-weight: 600;
}

/* 右侧提示卡片样式 */
.side-card .layui-timeline {
  padding: 0;
}

.side-card .layui-timeline-item {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f5f5f7;
}

.side-card .layui-timeline-item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.side-card .layui-timeline-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 6px;
}

.side-card .layui-timeline-content p {
  margin: 0;
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.5;
}

.side-card .layui-timeline-axis {
  color: #0071e3;
  font-size: 18px;
}
</style>
